import { toast } from "react-toastify";
import ApiBase from "./base";
import { LocalStorageKey } from "../shared/enums";
import i18n from "../translations";
import { jsonToQueryString } from "../shared/utils";

export const _TRANSACTION_URL = "transaction";

export async function getTransaction(params) {
  const response = await ApiBase.get(
    `${_TRANSACTION_URL}?${jsonToQueryString(params)}`
  );

  if (response.success) {
    response.items = response.items.map((e) => ({ ...e, ...e.user }));
  }

  return response;
}
